import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia"; //
import setupDesignSystem from "q2-design-system";

// Once setupDesignSystem is done executing your app will render
setupDesignSystem().then(() => {
  // --- set favicon once globally ---
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = "https://www.q2.com/hubfs/favicon.ico"; // place favicon.png in your public root
  document.head.appendChild(link);
  // --------------------------------

  const app = createApp(App);
  app.use(createPinia());

  app.use(router);
  app.mount("#app");
});
